export function Focus(ID: string) {
    window.requestAnimationFrame(function () {
        try {
            document.getElementById(ID).focus();
        } catch (ex) {
            console.error(`Focus(${ID}) error`, ex)
        }
    });
    return;
}